import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { useListSearch } from '../../../../hooks/generic/Form/useListSearch';
import ChrRadio from '../Basic/ChrRadio';
import { getDataFromProps, getUId, propagateData, updateDataList } from '../utils';

// props = {
//   data: [ <ChrRadio.data>, ...],
//   uId: <uniqueIdentifier in parent component data>,
//   inline: <boolean>,
//   onChange: <handler>,
//   submitText: <string>
// }

const RadioButtonGroup = (props) => {
  const formData = getDataFromProps(props);
  const myUId = getUId(props);

  let [ListSearchComponent, choicesList] = useListSearch({
    list: formData,
    searchable: props.searchable,
    listItemValueMapper: choice => choice.label,
    inputRef: props.searchRef
  });

  const onChangeHandler = (event, childUId, childData) => {
    // To set the checked value of other ChrRadio components to false
    let newFormData = safeMutate(formData, draftData => {
      draftData.forEach(choice => choice.checked = (choice.uId === childUId));
    });
    newFormData = updateDataList(newFormData, childUId, childData);
    propagateData(event, myUId, newFormData, props);
  };

  return (
    <React.Fragment>
      { ListSearchComponent }
      <FormGroup className={ props.formGroupClass }>
        { choicesList.map((choice) => (
          <ChrRadio
            key={ choice.uId }
            data={ choice }
            uId={ choice.uId }
            onChange={ onChangeHandler }
          />
        )) }
      </FormGroup>
    </React.Fragment>
  );
};

export default RadioButtonGroup;
